var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "disabled back arrow",
    d: "M0.323808 8.79208L7.11259 15.6716C7.54444 16.1095 8.2446 16.1095 8.67624 15.6716C9.10792 15.2342 9.10792 14.5246 8.67624 14.0872L2.66922 7.99988L8.67607 1.91276C9.10774 1.47513 9.10774 0.765684 8.67607 0.328226C8.2444 -0.109409 7.54426 -0.109409 7.11241 0.328226L0.323634 7.20786C0.107797 7.4267 2.79365e-07 7.7132 2.54305e-07 7.99985C2.29234e-07 8.28664 0.108006 8.57335 0.323808 8.79208Z",
    fill: "#AEB3BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledBackArrow);
export default __webpack_public_path__ + "static/media/disabled_back_arrow.295c946e4ebae932a1a8bcac708aa347.svg";
export { ForwardRef as ReactComponent };